import { render, staticRenderFns } from "./ServidorNew.vue?vue&type=template&id=3eb0f7d9&scoped=true&"
import script from "./ServidorNew.vue?vue&type=script&lang=js&"
export * from "./ServidorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0f7d9",
  null
  
)

export default component.exports